module.exports = __webpack_public_path__ + "static/media/up-triangle.2aa30359.svg";